module.exports = __webpack_public_path__ + "img/3.73baf138.svg";